{
  "version": 1,
  "asset_id": "a930fc04-8d46-4be7-84be-3f8ffe175c0a",
  "project_id": "115256dd-a6cc-4bc1-95c1-d787d4c0e481",
  "url": "/__l5e/assets-v1/a930fc04-8d46-4be7-84be-3f8ffe175c0a/brand-dicor.png",
  "r2_key": "a/v1/115256dd-a6cc-4bc1-95c1-d787d4c0e481/a930fc04-8d46-4be7-84be-3f8ffe175c0a/brand-dicor.png",
  "original_filename": "brand-dicor.png",
  "size": 29428,
  "content_type": "image/png",
  "created_at": "2026-07-14T02:53:44Z"
}
